<forge-text-field [invalid]="isInvalid" [required]="isRequired" density="small">
    <input #input type="text" [lgdCurrency]="config" [formControl]="formControl" autocomplete="off">
    <label *ngIf="!hideLabel" slot="label">{{label}}</label>

    <span slot="support-text">
        <ng-container *ngIf="showErrorMessage('required')">
            {{label}} is required
        </ng-container>

        <ng-container *ngIf="showErrorMessage('min')">
            {{label}} cannot be less than {{min | currency:'USD':'symbol':digitsInfo}}
        </ng-container>

        <ng-container *ngIf="showErrorMessage('max')">
            {{label}} cannot be more than {{max | currency:'USD':'symbol':digitsInfo}}
        </ng-container>

        <ng-container *ngIf="showErrorMessage('precision')">
            {{label}} cannot have more than {{precision}} digits
        </ng-container>

        <ng-container *ngIf="showErrorMessage('scale')">
            {{label}} cannot have more than {{scale}} decimal digits
        </ng-container>

        <ng-container *ngFor="let customError of customErrors">
            <ng-container *ngIf="showErrorMessage(customError.errorKey)">
                {{customError.message}}
            </ng-container>
        </ng-container>
    </span>

    <forge-tooltip>{{tooltip}}</forge-tooltip>
</forge-text-field>